import { motion, useReducedMotion } from "framer-motion";

/** Gentle fade-up on scroll; disabled entirely for reduced-motion users. */
const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const reduceMotion = useReducedMotion();
  const MotionTag = motion[as] || motion.div;

  if (reduceMotion) {
    return <div className={className}>{children}</div>;
  }

  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-60px" }}
      transition={{ duration: 0.5, ease: "easeOut", delay }}
    >
      {children}
    </MotionTag>
  );
};

export default Reveal;
